

























































import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public modelShow = false;
  public show() {
    this.modelShow = true;
  }
  public async downLoad(state) {
    if (state == 0) {
      window.location.href = this.$store.state.home.downList.pc_down_url;
    }
    // android
    if (state == 1) {
      window.location.href = this.$store.state.home.downList.android_down_url;
    }
    // // ipad随机企业签
    // if (state == 3) {
    //   const arr: any = JSON.parse(this.downLoadList.enterprise_signs)
    //   const sar = Math.floor((Math.random() * arr.length));
    //   window.location.href = arr[sar]
    // }
    // ipad随机企业签
    if (state == 3) {
      window.open("https://www.pgyer.com/nMJp/", "_blank");
      // window.location.href = "https://www.pgyer.com/nMJp/";
    }
  }
}
